import { useAuthTokenSync } from './use-auth-token-sync.hook';

/**
 * Headless component that activates {@link useAuthTokenSync}. Mount it under
 * `MiniappSdkProvider` so the token store can refresh via the host SDK.
 */
export const AuthTokenSync = (): null => {
  useAuthTokenSync();

  return null;
};
